import React, { useState, useEffect } from "react";
import "./AnimeBanner.css";

const AnimeBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("animeAwardsBannerDismissed", "true");
  };

  useEffect(() => {
    const isDismissed =
      localStorage.getItem("animeAwardsBannerDismissed") === "true";
    if (isDismissed) {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="anime-awards-banner">
      <div className="banner-background-elements">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="star star-1"></div>
        <div className="star star-2"></div>
        <div className="star star-3"></div>
      </div>

      <div className="banner-content">
        <div className="banner-logo-section">
          <div className="banner-logo">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/8a/Crunchyroll-Icon-White.svg"
              alt="Crunchyroll"
              width="40"
              height="40"
              className="crunchyroll-logo"
            />
            <div className="awards-badge">AWARDS</div>
          </div>
        </div>

        <div className="banner-text">
          <h2>Anime Awards 2025</h2>
          <p>
            Vote for your favorite anime of the year!{" "}
            <span className="highlight">Voting ends April 14</span>
          </p>
        </div>

        <div className="banner-actions">
          <a
            href="https://www.crunchyroll.com/animeawards/"
            target="_blank"
            rel="noopener noreferrer"
            className="banner-button"
          >
            Vote Now
          </a>
          <button
            className="banner-dismiss"
            onClick={handleDismiss}
            aria-label="Dismiss banner"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnimeBanner;
